export default __webpack_public_path__ + "static/media/spark_24.2d506fad.png";